import type { ReactNode } from 'react';
import styles from './ToolForm.module.css';

interface ToolFormSectionProps {
  step?: number;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

/** A numbered step in the tool authoring flow, shared by the HTTP and lookup forms. */
export const ToolFormSection = ({ step, title, subtitle, children }: ToolFormSectionProps) => (
  <fieldset className={styles.section}>
    <legend className={styles.legend}>
      {step !== undefined && <span className={styles.stepBadge}>{step}</span>}
      {title}
    </legend>
    {subtitle && <p className={styles.sectionSubtitle}>{subtitle}</p>}
    <div className={styles.sectionBody}>{children}</div>
  </fieldset>
);
